<template>
    <el-dialog title="店铺名称" :visible.sync="centerDialogVisible" width="600px" class="shopName">
        <div class="inputBox">
            <p class="title">店铺名称</p>
            <el-input v-model="shopName" placeholder="请输入店铺名称" maxlength="10" show-word-limit></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click.native="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import {updateShopSet} from 'api/accountApi'
export default {
    name: 'shopName',
    data() {
        return {
            centerDialogVisible: false,
            shopName: ''
        }
    },
    props: ['data'],
    mounted() {},
    methods: {
        confirm() {
            if (this.shopName) {
                this.setLoading(true)
                updateShopSet({
                    data: {hostshopname: this.shopName},
                    success: data => {
                        this.setLoading(false)
                        this.$message.success('设置成功')
                        this.centerDialogVisible = false
                        this.$emit('getMsg')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.error('请输入店铺名称')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    this.shopName = newV.hostshopname
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .shopName{
        .inputBox{
            display: flex;
            align-items: center;
            .title{
                margin: 0 40px 0 32px;
            }
            .el-input{
                width: 400px;
            }
        }
    }
</style>